export default "__VITE_ASSET__Dqcz7pqF__"